<template>
  <div class="recover-password">
    <div v-if="!sended">
      <h2>{{ $t("login.forgot-password")}}</h2>
      <p class="mb-0">{{ $t("recover-password.enter-the-email-of-your-account-and-we-will-send-you-an-email-with-the-instructions-to-recover-your-password") }}</p>
      <el-form :model="form" size="medium" >
        <el-form-item prop="email" :label="$t('login.email')" :rules="[
          { required: true, message: $t('recover-password.please-input-email-address'), trigger: 'blur' },
          { type: 'email', message: $t('recover-password.please-input-correct-email-address'), trigger: ['blur', 'change'] }
        ]">
          <el-input v-model="form.email" :disabled="loading"></el-input>
        </el-form-item>
        <el-button type="primary" class="button" :disabled="!form.email" @click="sendInstructions" :loading="loading">{{ $t('recover-password.send-instructions') }}</el-button>
        <p class="text-center">
          <router-link :to="{ name : 'Login' }">{{ $t("login.go-back-to-login")  }}</router-link>
        </p>
      </el-form>
    </div>
    <div v-else>
      <div v-if="success">
        <Success class="svg mb-2"></Success>
        <h2 class="text-center">{{ $t("recover-password.instructions-sended") }}</h2>
        <p class="text-center">{{ $t('recover-password.we-have-sent-to-your-email-the-instructions-to-be-able-to-recover-your-password', { email: form.email }) }}</p>
        <el-button type="primary" class="button" @click="$router.push({ name: 'Login'})">{{ $t("common.ok-got-it") }}</el-button>
      </div>
      <div v-else>
        <Error class="svg"></Error>
        <p class="text-center">{{ $t("recover-password.we-have-not-found-the-email", { email : this.form.email }) }}</p>
        <p class="text-center">{{ $t('common.click') }} <a href="#" @click="sended = false">{{ $t("common.here") }}</a> {{ $t("recover-password.to-try-another-email") }}</p>
        <router-link :to="{ name : 'Login' }">{{ $t("login.go-back-to-login")  }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/api/auth'
import Error from '@/components/icons/Error'
import Success from '@/components/icons/Success'
export default {
  data() {
    return {
      form : {
        email : ''
      },
      loading : false,
      sended : false,
      success : false
    }
  },
  methods : {
    sendInstructions() {
      this.loading = true
      auth.forgotPassword(this.form.email)
      .then(() => {
        this.success = true
      }).finally(() => {
        this.loading = false
        this.sended = true;
      })
    }
  },
  components : {
    Error, 
    Success
  }
}
</script>

<style scoped>

.svg {
  margin: 0 auto;
}


.button {
  width: 100%;
}

.button + p {
  margin: var(--column) 0;
}

</style>